import { render, staticRenderFns } from "./FieldVersionableFile.vue?vue&type=template&id=6458e831"
import script from "./FieldVersionableFile.vue?vue&type=script&lang=js"
export * from "./FieldVersionableFile.vue?vue&type=script&lang=js"
import style0 from "./FieldVersionableFile.vue?vue&type=style&index=0&id=6458e831&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports